<template>
  <div>

    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10"> 

        <div class="flex items-center justify-between flex-wrap">
            <h1
            class="py-2 text-xl text-center font-bold text-blues w-full md:w-auto"
            >
            Add Course with AI
            </h1>
            <router-link
            :to="{ name: 'AdminCoursess' }"
            class="bg-blues text-white rounded-lg hover:bg-[#18469d] hover:text-white text-sm font-semibold px-3 py-1 cursor-pointer"
            >Close</router-link
            >
        </div>

        <div>
          <form
            ref="addCourseRef"
            class="rounded-2xl pt-10 px-6 md:px-10 pb-10 overflow-y-auto bg-white"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
            @submit.prevent="createCourseAI"
          > 

          <div class="flex flex-col gap-3">
                <label for="short-desc" class="text-sm"
                  > Descritption for create course with ai </label
                >
                <textarea
                  id="short-desc"
                  placeholder="Descritption for create course with ai"
                  required
                  maxlength="1000"
                  class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                ></textarea>
              </div> 

              <div class="flex gap-3 flex-wrap items-center">
                <button
                  :disabled="disable_submit == true"
                  type="submit"
                  class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
                >
                  Create Course
                </button>

                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />

              </div>

          </form>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>

import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";

import axios from "axios";
import { mapGetters } from "vuex";


import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    FlashMessage,
    HodHeader,
    CoordinateHeader,
  },

 

  data() {
    return {
      
      messages: {
        text: "",
        type: "null",
      },
     
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
   
  },

  async created() {
   
  },

  methods: {
  },

};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
